<template>
    <el-dialog title="评价表建议" :visible.sync="visible" width="85%" class="BorderRadius" top="5vh"
        :close-on-press-escape="false" :close-on-click-modal="false" :before-close="CloseDig">
        <div class="DigTable MaxHei">
            <div class="DigTableTop TableBg">
                <div class="DigTableBor Wid30 TablePad">评价指标</div>
                <div class="DigTableBor Wid70 TablePad">评定打分</div>
            </div>
            <div class="DigTableHead" v-for="item in NewItemList" :key="item.id">
                <div class="DigTableDis">
                    <div class="ItemDis DigTableBor Wid30">
                        <div class="ItemTit">{{item.indicator}}</div>
                        <div class="ItemFuTit">
                            <!-- <div>{{item.description}}</div> -->
                            <el-input v-if="item.description" readonly :autosize="{ minRows: 3, maxRows: 8 }" class="Wid" type="textarea" size="medium" placeholder="请输入描述" v-model="item.description"></el-input>
                            <!-- <div class="ItemQz">权重：{{item.weight}}</div> -->
                        </div>
                    </div>
                    <div class="DigTableBor Wid70">
                        <div class="ItemRadio">
                            <!-- <label class="Radio" :style="{'width':(100/(item.score+1))+'%'}"
                                v-for="(i,num) in item.score+1">
                                <div class="RadioCer"><input disabled type="radio" :name="'Radio'+item.id" :value="num"
                                        v-model="item.rating">{{num}}</div>
                            </label> -->
                            <div class="ItemRadioFlex">{{item.score}}分</div>
                        </div>
                        <div class="ItemRadioMsg">
                            <div class="ItemRadioMsgDom" v-for="i in item.text_content"
                                :style="{'width':(100/(item.score+1)*((i.maxScore-i.minScore)+1))+'%'}">
                                <div class="RadioCer"><span>{{i.tipText}}</span></div>
                            </div>
                            <!-- <div class="ItemRadioFlex">{{item.text_content}}</div> -->
                        </div>
                    </div>
                </div>
                <template v-if="Type">
                    <div class="ItemMsg"><el-input class="Wid" placeholder="请输入意见建议" v-model="item.gl_yj"> </el-input></div>
                </template>
            </div>
        </div>
        <div class="DigItem" v-if="ZuZhang">
            <el-input class="Wid" type="textarea" :rows="8" placeholder="请输入综合意见及建议" v-model="Remark"> </el-input>
        </div>
        <div slot="footer" v-if="Type">
            <el-button v-throttle size="small" @click="CloseDig">取消</el-button>
            <el-button v-throttle class="BgColor" size="small" type="primary" @click="SucData(1)">提交</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "AuditScoreDialog",
        props: {
            // 弹窗显隐状态 - 父组件传值
            visible: {
                type: Boolean,
                default: false
            },
            // 评分规则列表 ItemList - 父组件传入核心数据
            itemList: {
                type: Array,
                default: () => []
            },
            // 综合意见 - 父组件传入
            auditRemark: {
                type: String,
                default: ""
            },
            Type: {
                type: String,
                default: ""
            },
            ZuZhang: {
                type: Number,
                default: 0
            },
            BaoCun: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                Remark: this.auditRemark,
                NewItemList: JSON.parse(JSON.stringify(this.itemList)) 
            };
        },
        watch: {
            auditRemark(newVal) {
              this.Remark = newVal;
            },
            // ✅ 监听父组件itemList变化，同步更新本地数组
            itemList(newVal) {
              this.NewItemList = JSON.parse(JSON.stringify(newVal));
              console.log(this.NewItemList)
              
            }
          },
        computed: {
            // 实时计算总评分，保留原有计算逻辑
            GetScoreNum() {
                let total = 0;
                if (this.NewItemList && this.NewItemList.length > 0) {
                    this.NewItemList.forEach(i => {
                        const rating = Number(i.rating) || 0;
                        const weight = Number(i.weight) || 0;
                        total += weight * rating;
                    });
                }
                return total;
            }
        },
        methods: {
            CloseDig() {
                this.$emit("cancel");
            },
            SucData(n) {
                this.$emit("submit",this.NewItemList,n,this.Remark);
            }
        }
    };
</script>

<style scoped>
    .MaxHei{
        max-height: 500px;
        overflow-y: auto;
    }
    .TableBg {
        background: #dcdcdc;
    }

    .TablePad {
        padding: 10px 0;
        font-weight: 700;
    }

    .Wid30 {
        width: 35%;
    }

    .Wid70 {
        width: 65%;
    }

    .TableNum {
        padding-bottom: 10px;
        font-weight: 700;
    }

    .Red {
        color: red;
    }

    .DigTable {
        border: 1px solid #028b8b;
        margin-bottom: 10px;
    }

    .DigTableTop {
        display: flex;
        border-bottom: 1px solid #028b8b;
    }

    .DigTableHead {
        border-bottom: 1px solid #028b8b;
    }

    .DigTableDis {
        display: flex;
    }

    .ItemDis {
        display: flex;
        align-items: center;
    }

    .DigTableBor {
        text-align: center;
        border-right: 1px solid #028b8b;
    }

    .DigTableBor:last-child {
        border: 0;
    }

    .ItemTit {
        width: 130px;
        font-weight: 500;
        font-size: 18px;
        padding: 5px;
    }

    .ItemFuTit {
        flex: 1;
        padding: 5px;
        min-height: 55px;
        border-left: 1px solid #028b8b;
        text-align: center;
    }

    .ItemQz {
        padding-top: 5px;
    }

    .ItemRadio {
        height: 50%;
    }
    .ItemRadioFlex{
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .ItemRadio .Radio {
        height: 100%;
        display: inline-block;
        position: relative;
    }

    .RadioCer {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
    }

    .RadioCer input {
        margin-top: 0;
    }

    .RadioCer span {
        font-size: 12px;
    }

    .ItemRadio .Radio::after {
        position: absolute;
        content: "";
        top: 0;
        right: 0;
        height: 100%;
        border-right: 1px solid #028b8b;
    }

    .ItemRadioMsg {
        height: 50%;
        border-top: 1px solid #028b8b;
    }

    .ItemRadioMsg .ItemRadioMsgDom {
        height: 100%;
        display: inline-block;
        position: relative;
    }

    .ItemRadioMsg .ItemRadioMsgDom::after {
        position: absolute;
        content: "";
        top: 0;
        right: 0;
        height: 100%;
        border-right: 1px solid #028b8b;
    }

    .ItemMsg {
        padding: 5px;
        border-top: 1px solid #028b8b;
    }

    .ItemRadio .Radio:last-child::after,
    .ItemRadioMsg .ItemRadioMsgDom:last-child::after,
    .DigTableHead:last-child {
        border: 0;
    }

    .DigItem {
        width: 100%;
    }

    .Wid {
        width: 100%;
    }
</style>